import { findByTruncatedName } from "./krStocks";
// 단일주식선물(단선) 기초자산 → KRX 코드/시장 매핑
// 키가 되는 종목명은 키움 잔고의 "축약 종목명"(예: "이수페타시", "LG디스플레") 기준.
// 코드/시장(KS=코스피, KQ=코스닥)은 사용자 _regime_px_400.pkl(26종) + KRX/웹(6종)으로 교차검증. (2026-08 기준)
// 새 단선 종목이 생기면 여기에 축약명→{code, market, name} 한 줄 추가하면 됨.
export const FUTURES_UNDERLYING = {
  "현대차":       { code: "005380", market: "KS", name: "현대차" },
  "HPSP":         { code: "403870", market: "KQ", name: "HPSP" },
  "코미코":       { code: "183300", market: "KQ", name: "코미코" },
  "삼성SDI":      { code: "006400", market: "KS", name: "삼성SDI" },
  "LG전자":       { code: "066570", market: "KS", name: "LG전자" },
  "HD마린엔진":   { code: "071970", market: "KS", name: "HD현대마린엔진" },
  "이수페타시":   { code: "007660", market: "KS", name: "이수페타시스" },
  "현대제철":     { code: "004020", market: "KS", name: "현대제철" },
  "LG디스플레":   { code: "034220", market: "KS", name: "LG디스플레이" },
  "미래에셋증":   { code: "006800", market: "KS", name: "미래에셋증권" },
  "SK하이닉스":   { code: "000660", market: "KS", name: "SK하이닉스" },
  "이마트":       { code: "139480", market: "KS", name: "이마트" },
  "NAVER":        { code: "035420", market: "KS", name: "NAVER" },
  "S-Oil":        { code: "010950", market: "KS", name: "S-Oil" },
  "롯데쇼핑":     { code: "023530", market: "KS", name: "롯데쇼핑" },
  "삼성카드":     { code: "029780", market: "KS", name: "삼성카드" },
  "LG이노텍":     { code: "011070", market: "KS", name: "LG이노텍" },
  "NH투자증권":   { code: "005940", market: "KS", name: "NH투자증권" },
  "삼성물산":     { code: "028260", market: "KS", name: "삼성물산" },
  "삼성화재":     { code: "000810", market: "KS", name: "삼성화재" },
  "HL만도":       { code: "204320", market: "KS", name: "HL만도" },
  "신세계":       { code: "004170", market: "KS", name: "신세계" },
  "코스맥스":     { code: "192820", market: "KS", name: "코스맥스" },
  "크래프톤":     { code: "259960", market: "KS", name: "크래프톤" },
  "SK스퀘어":     { code: "402340", market: "KS", name: "SK스퀘어" },
  "펄어비스":     { code: "263750", market: "KQ", name: "펄어비스" },
  "한화오션":     { code: "042660", market: "KS", name: "한화오션" },
  "대한전선":     { code: "001440", market: "KS", name: "대한전선" },
  "현대로템":     { code: "064350", market: "KS", name: "현대로템" },
  "고영":         { code: "098460", market: "KQ", name: "고영" },
  "미스토홀딩":   { code: "081660", market: "KS", name: "미스토홀딩스" },
  "이녹스첨단":   { code: "272290", market: "KQ", name: "이녹스첨단소재" },
};

// 단선 축약명 → { code, market, name }. 미매칭이면 null (호출측에서 종목명 폴백).
export function resolveFuturesUnderlying(rawName) {
  const n = String(rawName || "").trim();
  if (!n) return null;
  if (FUTURES_UNDERLYING[n]) return FUTURES_UNDERLYING[n];
  // 축약/전체명 차이 흡수용 접두 매칭. 길이 차 제한이 없으면 "HD"가
  // HD마린엔진에, "NH"가 NH투자증권에 걸리는 식으로 엉뚱한 코드가 들어간다.
  const key = Object.keys(FUTURES_UNDERLYING).find(
    k => (k.startsWith(n) || n.startsWith(k)) && Math.abs(k.length - n.length) <= 3,
  );
  if (key) return FUTURES_UNDERLYING[key];
  // 위 맵은 손으로 관리하는 32종목뿐이라 새 단선 종목은 늘 빠져 있다.
  // 583종목 마스터에서 잘린 이름을 복원해 본다. 후보가 여럿이면 null이라
  // 잘못된 코드가 들어갈 일은 없고, 기존처럼 종목명 폴백으로 넘어간다.
  // 단선은 보통주에만 상장되므로 보통주/우선주 갈림은 보통주로 확정해도 된다
  const hit = findByTruncatedName(n, { preferCommon: true });
  return hit ? { code: hit.c, market: hit.m, name: hit.n } : null;
}
